
import { Component, Vue } from 'vue-property-decorator';
import {IPage} from "@/js/page";
import {userApi} from "@/api/organization";
import {auditApi} from "@/api/audit";
import SetTableColumns from "@/components/SetTableColumns.vue"

@Component({
  name: "adminOrganList",
  components: {SetTableColumns}
})
export default class Home extends Vue {
  listParam: IPage = {
    size: 10,
    current: 1,
  };
  modeType = "0";
  listData = [];
  listTotal = 0;
  listTotal0 = "";
  listTotal1 = "";
  allSelected = [];
  memberList = [] as any;  //成员列表
  setDialog = false;
  userId = "";

  screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
  tabCol = [];
  tableKey = 0;

  created(){
    const route = this.$route;
    const q = JSON.parse(JSON.stringify(route.query));
    if(q.modeType){
      this.modeType = q.modeType;
    }
    if(q.size){
      this.listParam.size = Number(q.size);
      this.listParam.current = Number(q.current);
    }
    this.getConfig();
  }
  activated(){
    if (this.$route.meta && !this.$route.meta.isBack) {
      this.listParam.current = 1;
    }
    this.tableClearSelect();
    this.getTaskNumber();
  }
  tableClearSelect(){
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    if($table){
      $table.clearSelection();
    }
  }
  getConfig() {
    userApi.getUserConfig({name: "adminOrganPageSize"}).then(r => {
      if (r.data.result == 0) {
        const rData = r.data.data;
        if (rData) {
          this.listParam.size = Number(rData.config);
        }
        this.getTaskNumber();
      }
    })
  }
  getTaskNumber(){
    this.list("0");
    this.list("1");
    if(this.modeType == "2"){
      this.list("2");
    }
  }
  changeTabCol(e: any) {
    this.tabCol = e;
    this.$nextTick(()=>{
      let $table = this.$refs.table as HTMLFormElement;
      if($table){
        $table.doLayout();
      }
      this.tableKey = Math.random();
    })
  }
  indexMethod(index: any) {
    return (this.listParam.current-1)*this.listParam.size+index+1;
  }
  handleClick(){
    this.allSelected = [];
    let $table = this.$refs.table as HTMLFormElement;
    if($table){
      $table.clearSelection();
    }
    this.refresh();
  }
  list(modeType: string = this.modeType){
    const route = this.$route;
    let q = JSON.parse(JSON.stringify(route.query));
    q = Object.assign(q,{modeType: this.modeType}, this.listParam);
    for (const key in q) {
      q[key] = String(q[key]);
    }

    auditApi.auditOrders({
      type: modeType?modeType:this.modeType,
      submitType: 1,  //已提交的
      ...this.listParam
    }).then(r=>{
      if(r.data.result == 0){
        const rData = r.data.data;
        if(this.modeType == modeType){
          this.listData = rData.records;
          this.listTotal = rData.total;
        }
        if(modeType == "0"){
          this.listTotal0 = rData.total;
        }else if(modeType == "1"){
          this.listTotal1 = rData.total;
        }
        this.$nextTick(()=>{
          let $table = this.$refs.table as HTMLFormElement;
          if($table){
            $table.doLayout();
          }
        })
      }
    })
  }
  pageSizeChange(val: number) {
    this.listParam.size = val;
    this.refresh();
    userApi.updateUserConfig({name: "adminOrganPageSize", config: val})
  }
  pageCurrentChange(val: number) {
    this.listParam.current = val;
    this.list();
  }
  memberSelect(selection: any, row: any) {
    this.allSelected = selection;
  }
  //打开处理人列表
  appointBtn(){
    if(this.allSelected.length == 0){
      this.$message.error("请先勾选任务");
      return;
    }
    this.userId = "";
    userApi.listHaveRightUser({
      right: "audit_order"
    }).then(r=>{
      if(r.data.result == 0){
        const rData = r.data.data;
        this.memberList = rData;

        if(this.memberList.length > 0){
          this.setDialog = true;
        }else{
          this.$message.warning("你单位还没有个人注册或人员绑定！");
        }
      }
    })
  }
  saveBtn(){
    if(!this.userId){
      this.$message.error("请选择一个处理人");
      return;
    }
    const person = {
      orderIds: this.allSelected.flatMap((e:any)=>e.id).join(","),
      userId: this.userId,
      userName: this.memberList.find((e:any)=>e.id == this.userId).name
    }
    auditApi.auditOrderDistribute(person).then(r=>{
      if(r.data.result == 0){
        this.$message.success("设置成功");
        this.setDialog = false;
        this.handleClick();
        this.getTaskNumber();
      }
    })
  }
  //退回
  returnBtn(row: any){
    this.$confirm("确认要退回到业务大厅吗?","确认操作",{type:"warning"})
      .then(()=>{
        auditApi.returnAuditOrder({ids: row.id}).then(r => {
          if(r.data.result === 0){
            this.$message("退回成功");
            this.handleClick();
          }
        })
      })
  }

  //右侧操作按钮 type 0编辑  1查看
  rightBtn(type: number){
    const dataArr = this.allSelected as any;
    if (dataArr.length == 0) {
      this.$message.error("请先勾选");
      return;
    }
    if (dataArr.length > 1) {
      this.$message.error("只能勾选一条");
      return;
    }
    if(type === 2){
      this.returnBtn(dataArr[0]);
      return;
    }
    this.toDetail(dataArr[0].id, type);
  }
  toDetail(id: number, type: number){
    this.$router.push("/qj/adminOrgan/detail/" + id + "/" + type);
  }
  refresh() {
    this.listParam.current = 1;
    this.list();
  }
}
